import React from 'react'
import Home from './Home'


function App() {
// This is a function when called will toggle the previous mode.
  return (
    <Home />
  )
}

export default App